import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import type { Session } from '@supabase/supabase-js'
import App from './App'
import { LoginScreen } from './components/LoginScreen'
import { supabase } from './supabase'
import { ThemeProvider } from './contexts/ThemeContext'
import './index.css'

function Root() {
  const [session, setSession] = useState<Session | null | undefined>(undefined)
  useEffect(() => {
    supabase.auth.getSession().then(({data}) => setSession(data.session))
    const { data } = supabase.auth.onAuthStateChange((_event, next) => setSession(next))
    return () => data.subscription.unsubscribe()
  }, [])
  if (session === undefined) return <div className="min-h-screen flex items-center justify-center">Carregando...</div>
  return session ? <App /> : <LoginScreen />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><ThemeProvider><Root /></ThemeProvider></React.StrictMode>
)
